import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
import translationNl from './nl.json';

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        resources: {
            nl: {
                translation: translationNl
            }
        },
        lng: 'nl',
        fallbackLng: 'nl',
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
